import React from 'react';
import { Construction } from 'lucide-react';

export default function AdminGeoPlaceholder({ title, description }) {
  return (
    <div style={{
      display: 'flex', flexDirection: 'column', alignItems: 'center',
      justifyContent: 'center', height: '100%', gap: 16,
      color: '#64887a', fontFamily: 'Inter, sans-serif',
    }}>
      <div style={{
        width: 56, height: 56, borderRadius: 14,
        background: 'rgba(34,197,94,0.1)', border: '1px solid rgba(34,197,94,0.2)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
      }}>
        <Construction size={24} color="#22c55e" />
      </div>
      <div style={{ textAlign: 'center' }}>
        <div style={{ fontSize: 16, fontWeight: 700, color: '#e2f0e8', marginBottom: 6 }}>
          {title}
        </div>
        <div style={{ fontSize: 13, maxWidth: 320, lineHeight: 1.6 }}>
          {description || 'Ce module est en cours de développement. Les APIs backend seront connectées prochainement.'}
        </div>
      </div>
    </div>
  );
}
